export default "__VITE_ASSET__53162d15__"